<!-- Energy widget version: 1.0 -->
<script lang="ts">
	import { devices, rooms } from 'src/stores';
	import EmRoomChart from 'src/components/EnergyMonitoring/sections/EmRoomChart.svelte';
	import EmWidgetState from 'src/components/EnergyMonitoring/EmWidgetState.svelte';
	import { getRoomsWithPmDevices } from 'src/components/Dashboards/dash-energy-helpers';
	import { getControlsForEnergyConfig } from 'src/components/Dashboards/dash-energy-period';
	import {
		ENERGY_ADD_DEVICE_HREF,
		hasPowerMeterDevices,
	} from 'src/components/EnergyMonitoring/helpers/energy_widget_state_helpers';
	import { Container } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';
	import type { DashEnergyWidgetConfig } from 'src/components/Dashboards/dash-energy-types';

	export let energyConfig: DashEnergyWidgetConfig | undefined;
	export let staticPreview = false;

	$: config = energyConfig ?? { period: 'live' };
	$: previewMode = staticPreview || (energyConfig as { galleryPreview?: boolean })?.galleryPreview;
	$: controls = getControlsForEnergyConfig(config);
	$: pmRooms = getRoomsWithPmDevices().filter((room) => $rooms[room.id]);
	$: requestedRoomIds = (config as { roomIds?: number[] }).roomIds;
	$: visiblePmRooms = pmRooms.filter(
		(room) => !requestedRoomIds?.length || requestedRoomIds.includes(Number(room.id)),
	);
</script>

<div class="dash-energy-room-grid">
	{#if previewMode}
		<EmRoomChart
			roomId={-101}
			{controls}
			periodId={config.period}
			staticPreview
			previewRoomName="Living room"
		/>
		<EmRoomChart
			roomId={-102}
			{controls}
			periodId={config.period}
			staticPreview
			previewRoomName="Kitchen"
		/>
	{:else if visiblePmRooms.length}
		{#each visiblePmRooms as room (room.id)}
			<EmRoomChart
				roomId={Number(room.id)}
				{controls}
				periodId={config.period}
				staticPreview={previewMode}
			/>
		{/each}
	{:else}
		<Container type="glass" noScroll fullHeight>
			<EmWidgetState
				kind="setup"
				message={hasPowerMeterDevices($devices)
					? $format('energy_monitoring_room_assign_meter', {
							default: 'Assign a power meter to a room to see room consumption.',
						})
					: $format('energy_monitoring_state_room_meter_setup', {
							default: 'Add a power meter to see room consumption.',
						})}
				minHeight="180px"
				actionHref={!hasPowerMeterDevices($devices) ? ENERGY_ADD_DEVICE_HREF : ''}
				actionLabel={!hasPowerMeterDevices($devices)
					? $format('button_add_device', { default: 'Add device' })
					: ''}
			/>
		</Container>
	{/if}
</div>

<style>
	.dash-energy-room-grid {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: var(--spacing-m);
		min-width: 0;
	}

	@media (max-width: 760px) {
		.dash-energy-room-grid {
			grid-template-columns: minmax(0, 1fr);
		}
	}
</style>
